import { render, staticRenderFns } from "./UploadScanModal.vue?vue&type=template&id=207af680&scoped=true&"
import script from "./UploadScanModal.vue?vue&type=script&lang=js&"
export * from "./UploadScanModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadScanModal.vue?vue&type=style&index=0&id=207af680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207af680",
  null
  
)

export default component.exports